import { useState } from 'react'
import type { Me } from '@/lib/api'
import { stopViewingAs } from '@/lib/viewAs'
import { Button } from './ui/button'

// While the owner views the app as a test person: always on screen, above the tabs, with the way back.
export function ViewingAs({ me }: { me: Me }) {
  const [leaving, setLeaving] = useState(false)
  if (!me.viewAs) return null
  return (
    <div
      role="status"
      className="fixed bottom-[calc(var(--tabs-clear)+0.75rem-var(--vv-below))] left-1/2 z-40 flex w-max max-w-[calc(100%-1.5rem)] -translate-x-1/2 items-center gap-3 rounded-full bg-primary py-1.5 pr-1.5 pl-5 text-sm text-primary-foreground shadow-float nav:bottom-5"
    >
      <span className="min-w-0 truncate">
        Viewing as <strong className="font-semibold">{me.name}</strong>, a test person
      </span>
      <Button
        size="sm"
        variant="secondary"
        disabled={leaving}
        onClick={() => {
          setLeaving(true)
          stopViewingAs().catch(() => setLeaving(false))
        }}
      >
        Back to you
      </Button>
    </div>
  )
}
